<template>
  <b-modal
    id="view_bed"
    title="EDITAR LEITO"
    no-close-on-backdrop
    hide-footer
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <b-form @submit.prevent="evOnSubmit">
      <b-row>
        <b-col>
          <label-required-field label="Número" />
          <b-input ref="autofocus" v-model="number" />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>Andar</label>
          <b-input v-model="walk" />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>ALA/Setor</label>
          <b-input v-model="ward_or_sector" />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>Quarto</label>
          <b-input v-model="bedroom" />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h6 v-if="bed" class="mb-0 worksansr">
            Criação:
            {{ formatDate(bed.created_at) }}
          </h6>
          <h6 v-if="bed" class="mb-0 worksansr">
            Última alteração:
            {{ formatDate(bed.updated_at) }}
          </h6>
        </b-col>
      </b-row>
      <warning-required-fields />
      <errors-messages :errors="errors" />
      <b-row align-h="between">
        <b-col cols="auto">
          <v-btn
            :disabled="loading"
            class="btn-cancel"
            @click="$bvModal.hide('view_bed')"
          >
            CANCELAR
          </v-btn>
        </b-col>
        <b-col cols="auto">
          <v-btn :disabled="loading" class="btn-delete ml-2" @click="remove">
            <i class="fas fa-trash mr-2 text-twenty" />
            {{ loading ? "Carregando" : "EXCLUIR" }}
          </v-btn>
          <v-btn :disabled="loading" type="submit" class="btn-save ml-2">
            <i class="fas fa-save mr-2 text-twenty" />
            {{ loading ? "Carregando" : "SALVAR" }}
          </v-btn>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import toast from "../../lib/ToastNotification";
import api from "../../services/api";
import permission from "../../lib/permission";
import { formatDate } from "../../lib/format";
import ErrorsMessages from "../Components/ErrorsMessages.vue";
import LabelRequiredField from "../Components/LabelRequiredField.vue";
import WarningRequiredFields from "../Components/WarningRequiredFields.vue";

export default {
  name: "ViewBed",

  components: {
    LabelRequiredField,
    WarningRequiredFields,
    ErrorsMessages,
  },

  props: {
    bed: Object,
  },

  data() {
    return {
      errors: [],
      loading: false,

      number: "",
      walk: "",
      ward_or_sector: "",
      bedroom: "",
    };
  },

  watch: {
    async bed(value) {
      if (!value) return;

      this.number = value.number;
      this.walk = value.walk;
      this.ward_or_sector = value.ward_or_sector;
      this.bedroom = value.bedroom;

      this.$bvModal.show("view_bed");
    },
  },

  methods: {
    permission,
    formatDate,

    async evOnShow() {
      this.errors = [];
      this.loading = false;
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnHide() {
      this.$emit("close");
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        this.errors = [];

        if (this.number.length > 50)
          this.errors.push("Informe até 50 caracteres no campo Nº");

        if (this.walk.length > 50)
          errors.push("Informe até 50 caracteres no campo Andar");

        if (this.ward_or_sector.length > 50) {
          this.errors.push("Informe até 50 caracteres no campo ALA/Setor");
        }

        if (this.bedroom.length > 50)
          this.errors.push("Informe até 50 caracteres no campo Quarto");

        if (this.errors.length > 0) {
          this.loading = false;
          return;
        }

        const data = {
          id: this.bed.id,
          number: this.number,
          walk: this.walk,
          ward_or_sector: this.ward_or_sector,
          bedroom: this.bedroom,
        };
        const response = await api.put("/rest-home/bed/update", data);
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.$bvModal.hide("view_bed");
          toast(message, "success");
          this.$emit("updated");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async remove() {
      try {
        this.loading = true;

        const data = { id: this.bed.id };
        const response = await api.delete("/rest-home/bed/delete", { data });
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.$bvModal.hide("view_bed");
          toast(message, "success");
          this.$emit("updated");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>